import React from 'react';

const NavLinksRight = ({ setIsMenuOpen }) => {
  return (
    <>
      <li>
        <a
          href="/#places"
          aria-label="Places to go"
          title="Places to go"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Places
        </a>
      </li>
      <li>
        <a
          href="/#blogs"
          aria-label="Travel Blogs"
          title="Travel Blogs"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Blogs
        </a>
      </li>
      <li>
        <a
          href="/#contact"
          aria-label="Contact Us"
          title="Contact Us"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Contact
        </a>
      </li>
    </>
  );
};

export default NavLinksRight;
